var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Question } from "./Question";
var Unit = /** @class */ (function () {
    function Unit(_a) {
        var drillType = _a.drillType, unitId = _a.unitId, unitNo = _a.unitNo, unitName = _a.unitName, questions = _a.questions;
        this.drillType = drillType;
        this.unitId = unitId;
        this.unitNo = unitNo;
        this.unitName = unitName;
        this.questions = questions;
    }
    Unit.fromApi = function (_a) {
        var questions = _a.questions, others = __rest(_a, ["questions"]);
        return new Unit(__assign(__assign({}, others), { questions: questions.map(Question.fromApi) }));
    };
    return Unit;
}());
export { Unit };
